<template>
  <div class="max-w-6xl mx-auto px-4 sm:px-6">
    <div class="pt-32 md:pt-40">
      <div class="text-center pb-12">
        <h1 class="h1 bg-clip-text text-transparent bg-linear-to-r from-slate-200/60 via-slate-200 to-slate-200/60 pb-4">YouTube Thumbnail Downloader</h1>
        <div class="max-w-3xl mx-auto">
          <p class="text-lg text-slate-400">Paste a YouTube video <span class="font-bold">URL</span> or <span class="font-bold">ID</span> below and we will fetch all available thumbnail images.</p>
        </div>
      </div>
    </div>
  </div>
</template>
<script lang="ts">
export default {
  //
};
</script>
